export default {
  apiTokensList: [],
  createdApiTokenResponse: {},
  status: {},
};